import moment from 'moment'

export default function(value) {
    return value ? moment.duration(Number(value), "minutes").asHours() : '' 
}